import { Tabs, Wrapper, useBreadcrumbRoutes } from '@maxtropy/components';
import styles from './index.module.scss';
import EnergyOverview from './EnergyOverview';
import ElectricMapConfig from './ElectricMapConfig';
import WaterConfig from './WaterConf';
import UseGasConfig from './GasConf';
import EnvironmentConfig from './EnvironmentConfig';

const MapConfiguration: React.FC = () => {
  const breadcrumbRoutes = useBreadcrumbRoutes();

  return (
    <Wrapper routes={[...(breadcrumbRoutes?.routes ?? [])]} className={styles.wrapper}>
      <Tabs
        items={[
          {
            label: '能源概览配置',
            key: '1',
            children: <EnergyOverview />,
          },
          {
            label: '电力地图配置',
            key: '2',
            children: <ElectricMapConfig />,
          },
          {
            label: '厂区水务配置',
            key: '3',
            children: <WaterConfig />,
          },
          {
            label: '用气监控配置',
            key: '4',
            children: <UseGasConfig />,
          },
          {
            label: '环保监控配置',
            key: '5',
            children: <EnvironmentConfig embedded />,
          },
        ]}
      />
    </Wrapper>
  );
};

export default MapConfiguration;
